export const styles = {
    global: {
        'html, body': {
            backgroundColor: 'white',
            color: 'slt-black.900',
        },
        body: {
            minHeight: '100vh',
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh',
        },
    },
};
